const ALL_DIMENSIONS = ["feature_id", "provider", "model"];
const FILTER_DIMENSIONS = ["feature_id", "provider", "model"];
const toUsageRequest = (search, timezone) => ({
  timerange: search.timerange,
  timezone,
  interval: "auto",
  group_by: ALL_DIMENSIONS,
  ...Object.fromEntries(
    FILTER_DIMENSIONS.filter((dimension) => search[dimension].length > 0).map((dimension) => [
      dimension,
      search[dimension]
    ])
  )
});
export default toUsageRequest;
